import { HttpContextToken } from '@angular/common/http';
import { CodeError, ErrorContentName } from './enums';
import { fe_products } from 'src/environments';

export const MAX_RUT_DIGITS = 9;
export const MAX_LENGTH_RUT = MAX_RUT_DIGITS + 3;
export const ALLOWED_KEYS = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
export const MAX_PHONE_DIGITS = 8;
export const MAX_OTP_DIGITS = 6;

export const RUT_PJ_THRESHOLD = 50000000;
export const CTE_APLICA = 'APLICA';
export const VALID_PASSWORD = 'VALIDO';

export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);

export const AES_KEY_SIZE = 32;
export const AES_IV_SIZE = 16;
export const AES_ALGORITHM = 'AES-CBC';
export const TEXT_ENCODING = 'utf8';

export const SIMULATOR_BY_TYPE = {
	ccfogape: fe_products.simuladorFogape,
	compracartera: fe_products.simuladorCompraCartera,
} as const;

export const HEADER_KEYS = {
	trackingId: 'Tracking-id',
	referenceOperation: 'Reference-Operation',
	uuid: 'Uuid',
	referenceService: 'Reference-Service',
} as const;

export const Patterns = {
	oneDigit: /^\d$/,
	onlyDigits: /\D/g,
	phone: /^\+569\d{8}$/,
	email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
	externalUrl: /^https?:\/\//,
	repeatDigits: /^(\d)\1+$/,
	twoDigitsRepeated: /^(\d{2})\1+$/,
};

export const SEQUENTIAL_NUMBER = {
	ASCENDING: '01234567890123456789',
	DESCENDING: '98765432109876543210',
} as const;

export const QUERY_PARAMS = {
	PRODUCT: 'producto',
	ORIGIN: 'origen',
} as const;

export const Links = {
	legal: {
		privacyPolicyBCI: 'https://www.bci.cl/corporativo/politicas-y-normas/politicas-de-privacidad',
	},
	institutional: {
		bciPyme: 'https://www.bci.cl/pyme',
		cmf: 'https://www.cmfchile.cl',
	},
};

export const RecaptchaActions = {
	checkPreapprovalValidity: 'checkPreapprovalValidity',
};

export const Steps = [
	{ name: 'Datos empresa' },
	{ name: 'Verificación de datos' },
	{ name: 'Simulación' },
];

export const ErrorToReturnContentName: Record<CodeError, ErrorContentName> = {
	[CodeError.OTP_VALIDATE_LIMIT]: ErrorContentName.OTP_LIMIT,
	[CodeError.OTP_GENERATION_LIMIT]: ErrorContentName.GENERIC_ERROR,
	[CodeError.INELIGIBLE_CUSTOMER]: ErrorContentName.INELIGIBLE_CUSTOMER,
	[CodeError.INVALID_TAX_FOLDER_PASSWORD]: ErrorContentName.INVALID_TAX_FOLDER_PASSWORD,
};

export const WhatsAppMessage =
	'¡Hola! Quiero hablar con un ejecutivo para abrir mi cuenta Bci Pyme. ¿Me ayudas con los pasos que debo seguir? 📝';

export const PURPOSES_ID_BY_PRODUCT: Record<string, { pj: string; png: string }> = {
	ccfogape: { pj: 'BPYM_WPUB_FOGAPE_PJ', png: 'BPYM_WPUB_FOGAPE_PNG' },
	compracartera: { pj: 'BPYM_WPUB_CONSOLIDAR_DEUDAS_PJ', png: 'BPYM_WPUB_CONSOLIDAR_DEUDAS_PNG' },
};
